import { render, staticRenderFns } from "./StaticSingleSelect.vue?vue&type=template&id=4a666d4f&"
import script from "./StaticSingleSelect.vue?vue&type=script&lang=js&"
export * from "./StaticSingleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports